import { ErrorBoundary, JSXElement, Match, mergeProps, Switch } from 'solid-js';
import { logErrorToSentry } from '~/utils/productLogging/sentry.ts';
import ContactSupport from '~/components/ErrorBoundaries/ContactSupport.tsx';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';
import { Localized } from '~/i18n';

type AgentPortalErrorBoundaryProps = {
  children: JSXElement;
};

export default function AgentPortalErrorBoundary(
  props: AgentPortalErrorBoundaryProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <ErrorBoundary
      fallback={(err) => {
        console.error(err);
        logErrorToSentry(err);
        return (
          <Switch fallback={<ContactSupport showLogo={false} />}>
            <Match
              when={
                err && err.message === AppErrors.AGENT_PORTAL_SESSION_EXPIRED
              }
            >
              <div class={`flex flex-col w-full justify-center items-center`}>
                <div class={`text-2xl`}>
                  {
                    <Localized
                      translationKey={`pages.link_expired.linked_expired_header`}
                    />
                  }
                </div>
                <div class={`mt-9`}>
                  {
                    <Localized
                      translationKey={`pages.link_expired.linked_expired_description`}
                    />
                  }
                </div>
              </div>
            </Match>
          </Switch>
        );
      }}
    >
      {merged.children}
    </ErrorBoundary>
  );
}
